import { computed, makeObservable, toJS } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import reports from 'modules/reports/store/collections/reports'
import Report, { type Variable } from 'modules/reports/store/models/Report'

export const VARIABLE_TYPES = {
  text: 'text',
  date: 'date',
  team: 'team',
}

interface IDashboard {
  [key: string]: any
}

class Dashboard extends Model<IDashboard> {
  constructor(attr: IDashboard = {}) {
    super(attr)
    makeObservable(this, {
      title: computed,
      description: computed,
      author: computed,
      reports: computed,
      isReadonly: computed,
      variables: computed,
    })
  }

  static urlRoot() {
    return '/api/rest/reports/dashboard'
  }

  get title(): string {
    return this.attributes.title
  }

  get identifier(): string {
    return this.attributes.identifier
  }

  get description(): string {
    return this.attributes.description
  }

  get authorId(): number {
    return this.attributes.author_id
  }

  get author(): User | null | undefined {
    return users.find({
      id: this.attributes.author_id,
    })
  }

  get reports(): Report[] {
    return reports.filter({
      dashboard_id: this.id,
    })
  }

  get variables(): Variable[] {
    const dashboardObj = this.toJS()

    if (!dashboardObj.variables) {
      return []
    }

    return toJS(dashboardObj.variables)
  }

  get isReadonly(): boolean {
    return this.attributes.is_readonly
  }
}

export default Dashboard
